var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDbnLogoInner = function SvgDbnLogoInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 247,
    viewBox: "0 0 220 247",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2147 246.274H0.442383V6.66436H63.2807V36.3738C77.8832 11.5412 106.64 0.330078 132.425 0.330078C191.844 0.330078 219.115 42.7081 219.115 95.3163V246.302H154.343V106.527C154.343 79.7329 141.198 58.7961 110.031 58.7961C81.7791 58.7961 65.2147 80.7138 65.2147 108.461V246.302V246.274Z",
    fill: "inherit"
  })));
};
export default SvgDbnLogoInner;